import { Box } from "@mui/material";
import styled from "styled-components";

export const NavbarStyled = styled(Box)``;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 7.36px;
  .MuiTypography-root {
    font-weight: 700;
    font-size: 18px;
    font-family: "Plus Jakarta Sans", sans-serif !important;
  }
`;
